import RouteUtils from '~/core/utils/RouteUtils';
import {dashboardPaths} from '~/paths';
import {OKTA_ROLE} from '~/config';

const routes = [
	{
		path: dashboardPaths.listingPage,
		title: 'Listings',
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ListingsPage');
		}),
	},
	{
		path: dashboardPaths.downloadCOCPage,
		title: 'Download COC',
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/DownloadCOCPage');
		}),
	},
].filter(r => r !== false); // Exclude dashboard page when in not in development

if (process.env.NODE_ENV === 'development') {
	routes.unshift({
		path: dashboardPaths.widget,
		title: 'Widget',
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./widgets/PolicyOverviewWidget');
		}),
	});
}

export default routes;
